export default function TypingText() {
    return (
        <div className="typing-container">Analysing your query...</div>
    );
};
